import { useEffect, useRef, useState } from 'react';

const VIDEO_URL = (import.meta as any).env?.VITE_DEMO_VIDEO_URL as string | undefined;
const POSTER_URL = (import.meta as any).env?.VITE_DEMO_POSTER_URL as string | undefined;

function AsciiWaveform() {
  return (
    <pre className="landing-ascii">{`
 ▁▂▃▅▇█▇▅▃▂▁  ▁▃▅▇██▇▅▃▁  ▁▂▅▇▅▂▁  ▁▃▅▇█▇▅▃▁
▁▃▅▇███▇▅▃▁  ▁▂▃▅▇█▇▅▃▂  ▁▃▅▇██▇▅▃  ▁▂▃▅▇▅▃▂▁
  ▁▂▃▅▇▅▃▂▁  ▁▃▅▇███▇▅▃  ▁▂▃▅▇█▇▅▃▂▁  ▁▃▅▇▅▃▁
▁▃▅▇█▇▅▃▁  ▁▂▅▇▅▂▁  ▁▃▅▇██▇▅▃▁  ▁▂▃▅▇███▇▅▃▂▁
          `}</pre>
  );
}

export function DemoVideo() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);
  const [prefersReduced, setPrefersReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReduced(mq.matches);
    const handler = (e: MediaQueryListEvent) => setPrefersReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  if (!VIDEO_URL) {
    return (
      <div className="landing-hero-visual">
        <AsciiWaveform />
      </div>
    );
  }

  const autoPlay = !prefersReduced;

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      void v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <div className="landing-hero-visual landing-hero-video-wrapper">
      <video
        ref={videoRef}
        className="landing-hero-video"
        src={VIDEO_URL}
        poster={POSTER_URL}
        autoPlay={autoPlay}
        muted
        loop
        playsInline
        preload="metadata"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onClick={toggle}
        aria-label="SmpleCut product demo"
      />
      {!playing && (
        <button
          type="button"
          className="landing-hero-video-play"
          onClick={toggle}
          aria-label="Play demo video"
        >
          ▶
        </button>
      )}
    </div>
  );
}
